import { Eyebrow } from "./Section";
import { money } from "../lib/market";

const Row = ({ label, value, strong, testId, sub }) => (
  <div className={`flex justify-between gap-4 py-2 ${strong ? "border-t border-white/10 mt-2 pt-3" : ""}`}>
    <div>
      <div className={`font-inter text-sm ${strong ? "text-white" : "text-white/70"}`}>{label}</div>
      {sub && <div className="font-inter text-[11px] text-white/40">{sub}</div>}
    </div>
    <div data-testid={testId} className={`font-montserrat tabular-nums ${strong ? "text-gold-200 text-lg" : "text-white/85 text-sm"}`}>{value}</div>
  </div>
);

/** Transparent fee breakdown: lawyer fee (100% to lawyer, 20/80) and separately disclosed platform fee. */
export const PriceBreakdown = ({ s, currency = "ngn", prefix = "price" }) => (
  <div data-testid={`${prefix}-breakdown`}>
    <Eyebrow className="mb-2">Fee breakdown</Eyebrow>
    <Row label="Lawyer's professional fee" sub="100% payable to the lawyer" value={money(s.professional_fee_minor, currency)} testId={`${prefix}-professional-fee`} />
    <div className="pl-4 border-l border-turquoise/30 my-1">
      <Row label={`Upfront tranche (${s.upfront_pct}%)`} sub="After payment is validated" value={money(s.upfront_minor, currency)} testId={`${prefix}-upfront`} />
      <Row label={`Completion tranche (${100 - s.upfront_pct}%)`} sub="After completion & review" value={money(s.final_minor, currency)} testId={`${prefix}-final`} />
    </div>
    <Row label="Platform marketplace fee" sub={s.sponsored ? "Waived — sponsored service" : s.platform_fee_minor ? `${s.platform_fee_rate}% · separate from the lawyer's fee` : "No platform fee currently active"}
      value={money(s.platform_fee_minor, currency)} testId={`${prefix}-platform-fee`} />
    {s.tax_minor > 0 && <Row label={`VAT on platform fee (${s.tax_rate}%)`} value={money(s.tax_minor, currency)} testId={`${prefix}-tax`} />}
    <Row label={s.sponsored ? "Funded by Justice Wallet" : "Total you pay"} value={money(s.gross_minor, currency)} strong testId={`${prefix}-total`} />
    <p className="font-inter text-[11px] text-white/35 mt-2">Processing charges are absorbed by the platform. Third-party costs (e.g. filing fees) are agreed separately with receipts.</p>
  </div>
);
